import { render, staticRenderFns } from "./footer-mobile.vue?vue&type=template&id=34447242&scoped=true&"
import script from "./footer-mobile.vue?vue&type=script&lang=js&"
export * from "./footer-mobile.vue?vue&type=script&lang=js&"
import style0 from "./footer-mobile.vue?vue&type=style&index=0&id=34447242&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34447242",
  null
  
)

export default component.exports